import { render, staticRenderFns } from "./main-partners.vue?vue&type=template&id=0a402cd7&scoped=true&"
import script from "./main-partners.vue?vue&type=script&lang=js&"
export * from "./main-partners.vue?vue&type=script&lang=js&"
import style0 from "./main-partners.vue?vue&type=style&index=0&id=0a402cd7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a402cd7",
  null
  
)

export default component.exports